import { useEffect, useRef, useState } from 'react'
import { useFloorplansContext } from './floorplans-context.jsx'

export default function PlanFilters() {
  const { bedroomOptions, bedroomsFilter, setBedroomsFilter, planLevelsFilter, setPlanLevelsFilter } = useFloorplansContext()
  const [isLevelsMenuOpen, setIsLevelsMenuOpen] = useState(false)
  const levelsDropdownRef = useRef(null)

  const levelOptions = [
    { value: 'all', label: 'All' },
    { value: 'level_1', label: 'Level 1' },
    { value: 'level_2', label: 'Level 2' },
    { value: 'level_3', label: 'Level 3' },
  ]

  const selectedLevelOption =
    levelOptions.find((option) => option.value === planLevelsFilter) || levelOptions[0]

  const formatLevelOptionLabel = (label) => label.replace(/^Level\s+/i, '')

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!levelsDropdownRef.current?.contains(event.target)) {
        setIsLevelsMenuOpen(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])

  const handleLevelsToggle = () => {
    setIsLevelsMenuOpen((isOpen) => !isOpen)
  }

  const handleLevelSelect = (levelValue) => {
    setPlanLevelsFilter(levelValue)
    setIsLevelsMenuOpen(false)
  }

  const handleLevelsKeyDown = (event) => {
    if (event.key === 'Escape') {
      setIsLevelsMenuOpen(false)
    }
  }

  return (
    <div className="plan-filters container-fluid">
      <fieldset>
        <div className="filter-bedrooms">
          <h2>Bedrooms</h2>

          <label htmlFor="bedrooms-all">
            <input
              id="bedrooms-all"
              type="radio"
              name="bedrooms-filter"
              value="all"
              checked={bedroomsFilter === 'all'}
              onChange={(event) => setBedroomsFilter(event.target.value)}
            />
            All
          </label>

          {bedroomOptions.map((option) => (
            <label key={option.value} htmlFor={`bedrooms-${option.value}`}>
              <input
                id={`bedrooms-${option.value}`}
                type="radio"
                name="bedrooms-filter"
                value={option.value}
                checked={bedroomsFilter === option.value}
                onChange={(event) => setBedroomsFilter(event.target.value)}
              />
              {option.short_label || option.label}
            </label>
          ))}
        </div>

        <div className="filter-levels">
          <h2>Levels</h2>
          <div
            className="mc-dropdown levels"
            ref={levelsDropdownRef}
            onKeyDown={handleLevelsKeyDown}
          >
            <button
              id="plan-levels-filter"
              type="button"
              className="levels-dropdown-toggle"
              aria-haspopup="listbox"
              aria-expanded={isLevelsMenuOpen}
              aria-controls="plan-levels-filter-list"
              onClick={handleLevelsToggle}
            >
              <span>{selectedLevelOption.label}</span>
            </button>

            <ul
              id="plan-levels-filter-list"
              className={`levels-dropdown-menu${isLevelsMenuOpen ? ' is-open' : ''}`}
              role="listbox"
              aria-labelledby="plan-levels-filter"
              hidden={!isLevelsMenuOpen}
            >
              {levelOptions.map((option) => (
                <li key={option.value} role="presentation">
                  <button
                    type="button"
                    role="option"
                    className={`levels-dropdown-option${planLevelsFilter === option.value ? ' is-selected' : ''}`}
                    aria-selected={planLevelsFilter === option.value}
                    onClick={() => handleLevelSelect(option.value)}
                  >
                    {formatLevelOptionLabel(option.label)}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </fieldset>
    </div>
  )
}